export enum ProlongTeamTaskAction {
	ProlongTeam,
	CloseTeam
}